module.exports = __webpack_public_path__ + "static/media/Fingpay 1.bcd35a81.png";